// extracted by mini-css-extract-plugin
export default {"icon":"Input_icon__hjbZx","input":"Input_input__4a1yi","wrapper":"Input_wrapper__-R8fB","label":"Input_label__KGODu","formInput":"Input_formInput__yEudB"};